import { FPPlugin } from "./plugins/fp/FPPlugin";
import { G2IPlugin } from "./plugins/g2i/G2IPlugin";
import { Auth0Plugin } from "./plugins/auth/Auth0Plugin";
import { EngageFlow } from "./plugins/engage/EngageFlow";
import { AppOptions } from "./application/options/AppOptions";
import { logService, eventsService } from "@Engage.Core";
import { PublicEvent } from "./core/events/PublicEvent";
/**
 * Main Engage SDK class
 */
export class Engage {
    constructor(options) {
        this.options = options;
    }
    /**
     * Build plugin URL
     */
    buildPluginUrl(resourceUrl, environment, version, name) {
        const baseUrl = resourceUrl.endsWith("/") ? resourceUrl : `${resourceUrl}/`;
        return `${baseUrl}${environment}/${version}/${name}`;
    }
    /**
     * Initialize SDK
     */
    async init() {
        const { environment, apiUrl, configCode, siteCode, clientCode, resourceUrl, g2i, auth0, settingsKey, attr, productCode, paperCode } = this.options;
        // Initialize core AppOptions singleton
        AppOptions.init({
            environment,
            apiUrl,
            configCode,
            siteCode,
            clientCode,
            resourceUrl,
            settingsKey,
            attr,
            productCode,
            paperCode
        });
        // Enable console logging + debug mode flag if requested.
        if (this.options.debug) {
            logService.setOptions({ debug: true });
            // Set localStorage flag so DebugPanel.init() shows the panel
            try {
                localStorage.setItem('nxt_debug', 'true');
            }
            catch ( /* localStorage unavailable */_a) { /* localStorage unavailable */ }
        }
        // Initialize events service — mirrors Connext v2: eventsService.init(PublicEvents)
        eventsService.init({ PublicEvent });
        // Subscribe publicEventHandlers — mirrors Connext v2 AppOptions.subscribePublicEvents()
        if (this.options.publicEventHandlers) {
            Object.entries(this.options.publicEventHandlers).forEach(([eventName, handler]) => {
                eventsService.subscribe(eventName, handler);
            });
        }
        // FP must complete first (writes anonDeviceId needed by views API)
        // G2I, Auth0, and EngageFlow can then run in parallel
        await new FPPlugin().init();
        const parallelTasks = [new EngageFlow().init()];
        if (g2i)
            parallelTasks.push(new G2IPlugin(g2i.config).init().catch(err => logService.warn("[G2IPlugin] init failed, continuing", err)));
        if (auth0)
            parallelTasks.push(new Auth0Plugin(auth0).init());
        await Promise.all(parallelTasks);
    }
}
